import styled, { createGlobalStyle } from 'styled-components';
import { Segment, Icon } from 'nallian-shared-ui/lib/components';

export const GlobalStyle = createGlobalStyle`
  .centeredModal {
    justify-content: center !important;
  }

  .modals ~ .modals {
    justify-content: center !important;
  }
`;

export const TagExplainer = styled.span`
  font-size: 0.8rem;
  opacity: 0.9;
`;

export const Hidden = styled.span`
  display: none;
`;

export const ValidPeriodWrapper = styled.span`
  ${props => props.green && `color: green;`}
  ${props => props.red && `color: red;`}
`;

export const NoBreakSpan = styled.div`
  white-space: nowrap;
`;

export const FiltersSegment = styled(Segment)`
  &.ui.segment {
    padding: 0.5rem;
  }

  & i.icon {
    height: 1.4em;
  }
`;

export const TableIcon = styled(Icon)`
  && {
    color: black;
  }
`;
